import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components/macro';

import { FloatingTextField } from '../../forms/FormStyles';
import Button from '../../standard/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../standard/Dialog';

const FooterControl = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px;
`;

const FooterButton = styled(Button)`
  font-size: 18px;
  min-width: 120px;
  height: 50px;
`;

export function CreateMatterCategoryDialog({ open, onClose, onSubmit }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isDirty, isValid, isSubmitSuccessful },
  } = useForm({ mode: 'onChange' });

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset();
    }
  }, [isSubmitSuccessful, reset]);

  return (
    <Dialog open={open} maxWidth="sm" onClose={onClose} fullWidth>
      <DialogHeader>
        <DialogTitle>Add New Category</DialogTitle>
      </DialogHeader>
      <DialogContent>
        <form id="create-category-form" onSubmit={handleSubmit(onSubmit)}>
          <FloatingTextField
            label="Name"
            InputProps={{
              ...register('name', {
                setValueAs: (v) => v?.trim(),
                required: true,
              }),
            }}
            autoFocus
          />
          <FloatingTextField
            label="Icon Name"
            InputProps={{
              ...register('icon', {
                setValueAs: (v) => v?.trim(),
                required: false,
              }),
            }}
          />
        </form>
      </DialogContent>
      <DialogFooter>
        <FooterControl>
          <FooterButton pure onClick={onClose} paletteType="gray">
            Cancel
          </FooterButton>
          <FooterButton
            type="submit"
            form="create-category-form"
            disabled={!isValid || !isDirty}
          >
            Add Category
          </FooterButton>
        </FooterControl>
      </DialogFooter>
    </Dialog>
  );
}
